import { Outlet } from 'react-router-dom';

export default function StoreLayoutPageLayout() {
    return (
        <>
            <Outlet />
        </>
    );
}
